//
//
//
//
//
//
//
//
//
//
//
//

import AppLink from "~/components/layout/AppLink.vue"
import logo from "~/components/Logo.vue"
import TogglerLang from '~/components/layout/TogglerLang'

export default {
	components: { AppLink, logo, TogglerLang },
	data() {
		return { atTop: true }
	},
	mounted() {
		if (this.$config.site_name !== 'seven-sisters-studio') return
		this._onScroll = () => { this.atTop = window.scrollY === 0 }
		window.addEventListener('scroll', this._onScroll, { passive: true })
	},
	beforeDestroy() {
		if (this._onScroll) window.removeEventListener('scroll', this._onScroll)
	},
}
